const limpiarHtml = (html = '') => html
  .replace(/<script[\s\S]*?<\/script>/gi, ' ')
  .replace(/<style[\s\S]*?<\/style>/gi, ' ')
  .replace(/<[^>]+>/g, ' ')
  .replace(/&nbsp;|&#160;/gi, ' ')
  .replace(/&[a-z]+;|&#\d+;/gi, ' ')
  .replace(/\s+/g, ' ')
  .trim();

const tieneEstructuraDeColumnas = (html = '') => (
  /(?:class|data-layout|data-columns)\s*=\s*["'][^"']*(?:two-columns|columns-2|column-layout|page-columns)[^"']*["']/i.test(html)
  || /style\s*=\s*["'][^"']*(?:column-count\s*:\s*2|grid-template-columns\s*:)[^"']*["']/i.test(html)
);

export const analizarDisposicionLectura = (html = '', columnasConfiguradas = 1) => {
  const texto = limpiarHtml(html);
  const palabras = texto ? texto.split(' ').length : 0;
  const densidad = palabras < 350 ? 'corta' : palabras < 1100 ? 'media' : 'extensa';
  const estructuraInterna = tieneEstructuraDeColumnas(html);
  const solicitaDosColumnas = String(columnasConfiguradas) === '2';

  return {
    palabras,
    densidad,
    estructuraInterna,
    usarDosColumnas: solicitaDosColumnas && !estructuraInterna,
  };
};
